import { StateType } from "client/utils"
import { MtDriveFile, MtDriveVersion } from "server/models"

export interface CcReviewDocumentProps {
    tab?: string
    fileId: number
    versionId: number
}

export interface CcReviewDocumentState {
    baseRoute: string
    activeTab: string

    fileList: MtDriveFile[]
    activeFile: MtDriveFile
    activeVersion: MtDriveVersion

    loadState: StateType
}

export const CC_REVIEW_DOCUMENT_BASE_ROUTE = "CC_REVIEW_DOCUMENT_BASE_ROUTE"
export const CC_REVIEW_DOCUMENT_ACTIVE_TAB = "CC_REVIEW_DOCUMENT_ACTIVE_TAB"

export const CC_REVIEW_DOCUMENT_FILE_LIST = "CC_REVIEW_DOCUMENT_FILE_LIST"
export const CC_REVIEW_DOCUMENT_ACTIVE_FILE = "CC_REVIEW_DOCUMENT_ACTIVE_FILE"
export const CC_REVIEW_DOCUMENT_ACTIVE_VERSION = "CC_REVIEW_DOCUMENT_ACTIVE_VERSION"
export const CC_REVIEW_DOCUMENT_LOAD_STATE = "CC_REVIEW_DOCUMENT_LOAD_STATE"
